module.exports = __webpack_public_path__ + "media/images/adaptative-b9ac1c89f9ccd2e9b20a0e0c4c2ace16.png";